const config = {
    // We use REACT_APP_API_URL if it's set (e.g. in environment variables),
    // otherwise we switch based on NODE_ENV.
    // Production: Truehost backend | Development: Local backend
    API_URL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
        ? 'https://nawirichesshouse.com/api'
        : 'http://localhost:5051/api')
};

export default config;
